import styled from 'foundations-theming/utils';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
const StyledText = styled.h1.withConfig({
  displayName: "Title__StyledText",
  componentId: "sc-1puhu7c-0"
})(({
  theme
}) => {
  return Object.assign({}, theme.typography['heading-1000'], {
    fontWeight: 200
  });
});
export const Title = props => {
  return (
    /*#__PURE__*/
    // @bend-expect trellis-tokenized
    _jsx(StyledText, {
      children: /*#__PURE__*/_jsx(FormattedMessage, Object.assign({}, props))
    })
  );
};